import { NgModule } from '@angular/core';

import { KeysPipe } from './keys.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { FilterPipe } from './filter.pipe';
import { CamelCaseToDashPipe } from './camelCaseToDash.pipe';
import { ReplaceStringPipe } from 'app/pipes/cartera/replace-string.pipe';
import { FacturaCheckboxPipe } from 'app/pipes/cartera/factura-checkbox.pipe';
import { FormatoFechaPipe } from 'app/pipes/cartera/formato-fecha.pipe';
import { FechaFormatoDtPipe } from 'app/pipes/fecha-formato-dt.pipe';

@NgModule({
    declarations: [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        ReplaceStringPipe,
        FacturaCheckboxPipe,
        FormatoFechaPipe,
        FechaFormatoDtPipe
    ],
    imports     : [],
    exports     : [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        ReplaceStringPipe,
        FacturaCheckboxPipe,
        FormatoFechaPipe,
        FechaFormatoDtPipe
    ]
})
export class FusePipesModule
{
}
